import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlightPathMiddle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 1001,
	height: 479,
	viewBox: "0 0 1001 479",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1000.54 0.250732C994.414 10.8146 966.411 85.5101 819.038 141.751C677.614 195.721 489.514 215.307 304.767 245.414C258.327 252.982 208.761 269.483 162.978 294.513M0.477539 478.751C21.7952 410.175 69.6235 355.677 127.478 316.22",
		stroke: "#176BEB",
		strokeDasharray: "10 10"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M147.45 317.224L147.983 306.159L153.647 302.906C156.074 301.512 157.4 299.137 157.108 297.691C156.006 296.71 153.286 296.657 150.859 298.051L145.195 301.304L135.369 296.186C134.767 295.886 134.189 296.003 133.796 296.444L133.242 296.977C132.815 297.545 132.77 298.217 133.176 298.737L138.721 305.021L135.14 308.153L131.319 307.12L129.7 308.049L132.833 311.63L134.347 316.141L135.965 315.212L136.999 311.39L141.509 309.876L144.142 317.833C144.386 318.446 144.988 318.746 145.694 318.663L146.4 318.581C147.013 318.336 147.405 317.896 147.45 317.224Z",
		stroke: "#176BEB",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgFlightPathMiddle;
